// Gate for pages that require a signed-in user. While the session is still being
// restored we render nothing (avoids a flash of the sign-in page on refresh);
// once known, an unauthenticated visitor is bounced to the sign-in screen.
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) return null;
  if (!user) return <Navigate to="/" replace />;
  return children;
}
